import * as Yup from 'yup';
import { emailSchema } from './emailValidation';

export const agreePolicySchema = Yup.object().shape({
  isAgreePolicy: Yup.boolean().oneOf([true], 'isAgreePolicy')
});
